<template>
  <WindowFrame
    class="ma-0 pa-0"
    :component="'sched'"
    :input_args="input_args"
  />
</template>
<script>
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";

export default {
  name: "Sched_esterno",
  components: { WindowFrame },
  props: {},
  data() {
    return {
      // Variabili d'appoggio
      input_args: {
       
      },

      // Modal
      // Array
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>